var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('video-player',{attrs:{"license-server":_vm.licenseServer,"manifest-url":_vm.manifestUrl,"poster-url":_vm.posterUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }